<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.cardTicketAddApplyList.push"
    :query-list="queryList"
  >
    <div slot="header-item">
      <v-select-apply-state
        class="table-filter-select"
        v-model="queryList.apply_state"
        @input="handleApplyStateChange"
        size="small"
        placeholder="审核状态"
      />
    </div>
    <v-column-time value="申请时间"/>
    <v-column-time v-if="currentState.timeLabel" :value="currentState.timeLabel" field="update_time"/>

    <v-column-avatar label="申请者" avatar-key="admin_avatar" nickname-key="admin_nickname"/>
    <el-table-column
      v-if="isAdministrator"
      label="申请者所属门店"
      width="150"
      align="center"
      prop="store_name"
    />

    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="课次券名称" align="center" prop="card_ticket_type_name"/>
    <el-table-column label="课次券价格" align="center">
      <template v-slot="{ row }">
        <span>{{ row.price | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="实际付款" align="center">
      <template v-slot="{ row }">
        <span>{{ row.actual_payment | toYuan }}</span>
      </template>
    </el-table-column>
    <el-table-column label="申请原因" align="center" prop="apply_remark"/>
    <el-table-column label="审核状态" align="center">
      <template v-slot="{ row }">
        <span
          v-for="applyState in findApplyState(row.apply_state)"
          :class="`${applyState.tagType}-color`"
          :key="`applyStateValue${applyState.value}`"
        >
          {{ applyState.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center">
      <template v-slot="{ row }">
        <v-list-button
          name="查看"
          icon="view"
          :to="RouteConfig.cardTicketAddApplyDetail.to(row.id)"
        />

        <template v-if="row.update_state === applyStates.review.value">
          <v-list-button
            v-if="isAdministrator"
            name="驳回"
            icon="reject"
            @click="handleReject(row)"
            :is-loading="isRejectingIds.includes(row.id)"
            :is-last="true"
            message="确定要驳回申请吗？"
          />

          <v-list-button
            v-else
            name="撤销"
            icon="restore"
            @click="handleRevoke(row)"
            :is-loading="isRevokingIds.includes(row.id)"
            :is-last="true"
            message="确定要撤销申请吗？"
          />
        </template>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`apply-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-title border-bottom">
              <span>{{ v.add_time | timeToYmdHi }}</span>
              <span>{{ v.store_name }}</span>
            </div>
            <div class="divider"></div>
            <div class="list-item-detail">
              <span>申请者</span>
              <v-avatar-nickname
                :value="v.admin_avatar"
                :nickname="v.admin_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>所属学员</span>
              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>
            <div class="list-item-detail">
              <span>课次券名称</span>
              <span>{{ v.card_ticket_type_name }}</span>
            </div>
            <div class="list-item-detail">
              <span>课次券价格</span>
              <span class="danger-color">{{ v.price | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>实际付款</span>
              <span class="success-color">{{ v.actual_payment | toYuan }}</span>
            </div>
            <div class="list-item-detail">
              <span>申请原因</span>
              <span>{{ v.apply_remark }}</span>
            </div>
            <div class="list-item-detail">
              <span>审核状态</span>
              <span
                v-for="applyState in findApplyState(v.apply_state)"
                :class="`${applyState.tagType}-color`"
                :key="`applyStateValue${applyState.value}`"
              >
                {{ applyState.name }}
              </span>
            </div>
            <div class="list-item-button">
              <v-list-button
                name="查看"
                icon="view"
                :to="RouteConfig.cardTicketAddApplyDetail.to(v.id)"
              />

              <v-list-button
                v-if="v.apply_state === applyStates.review.value && !isAdministrator"
                name="撤销"
                icon="restore"
                @click="handleRevoke(v)"
                :is-loading="isRevokingIds.includes(v.id)"
                :is-last="true"
                message="确定要撤销申请吗？"
              />
            </div>
          </div>
        </template>
        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { applyStates, findApplyState } from '@/enums/applyStates';
import { mapGetters } from 'vuex';
import { index, update, destroy } from '@/api/card-ticket-add-apply';
import { removeArrayItem } from '@/utils';
import { getLegalQueryList } from "@/utils/formats";

export default {
  name: RouteConfig.cardTicketAddApplyList.name,
  data: () => ({
    RouteConfig,
    count: 0,
    list: [],
    stores: [],
    queryList: {
      is_asc: 0,
      apply_state: applyStates.review.value,
      page: 1,
      size: 8,
    },
    isLoading: false,
    isDetailLoading: false,
    isShowDialog: false,
    isShowPassAllTip: false,
    isPassingAll: false,
    isRevokingIds: [],
    isPassingIds: [],
    isRejectingIds: [],
    applyInfo: {
      id: 0,
      update_state: applyStates.review.value,
      update_remark: '',
      store: {},
      administrator: {},
      student: {},
      old_student: {},
      card_name: '',
      card_type_name: '',
      card_number: '',
      is_generic: 0,
      is_number_limit: 0,
      is_private: 0,
      expire_number: 0,
      expire_days: 0,
      expire_time: 0,
      actual_payment: 0,
      card_payment_mode_name: '',
      payment_remark: '',
      old_card_name: '',
      old_card_type_name: '',
      old_card_number: '',
      old_is_generic: 0,
      old_is_number_limit: 0,
      old_is_private: 0,
      old_expire_number: 0,
      old_expire_days: 0,
      old_expire_time: 0,
      old_actual_payment: 0,
      old_card_payment_mode_name: '',
      old_payment_remark: '',
    },
    applyStates,
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'userStoreId',
    ]),
    currentState() {
      return findApplyState(this.queryList.apply_state)[0];
    }
  },
  methods: {
    findApplyState,
    refresh() {
      RouteConfig.cardTicketAddApplyList.push(this.queryList);
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    handleApplyStateChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    async load(route = this.$route, next) {
      const { queryList } = this;
      const { query } = route;

      getLegalQueryList(queryList, query);
      this.isLoading = true;
      const { isError, data } = await index(queryList);
      this.isLoading = false;
      if (isError) return;

      this.count = data.count;
      this.list = data.list;
      if (next) next();
    },
    async handleRevoke({ id }) {
      this.isRevokingIds.push(id);
      const { isError } = await destroy(id);
      removeArrayItem(this.isRevokingIds, id);
      if (isError) return;

      this.closeModal(id);
      this.load();
    },
    async handleReject({ id }) {
      this.isRejectingIds.push(id);
      const { isError } = await update(id);
      removeArrayItem(this.isRejectingIds, id);
      if (isError) return;

      this.closeModal(id);
      this.load();
    },
  },
  beforeMount() {
    this.load();
  },
};
</script>
